import { render, staticRenderFns } from "./HeadedView.vue?vue&type=template&id=68e4b2d9&scoped=true&"
import script from "./HeadedView.vue?vue&type=script&lang=js&"
export * from "./HeadedView.vue?vue&type=script&lang=js&"
import style0 from "./HeadedView.vue?vue&type=style&index=0&id=68e4b2d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e4b2d9",
  null
  
)

export default component.exports